


























































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import { Store } from 'vuex';
import MdIcon from '../../components/vui-luma/Ui/MdIcon.vue';

@Component({
  components: {
      MdIcon,
  },
})
export default class EventCard extends Vue {
  public popoverContainer = null;

  @Prop({default: 'mb-16pt'}) private cardClass!: string;
  @Prop({default: ''}) private title!: string;
  @Prop({default: ''}) private description!: string;
  @Prop({default: ''}) private image!: string;
  @Prop({default: ''}) private startDate!: string;
  @Prop({default: ''}) private duration!: number;
  @Prop({default: ''}) private startTime!: string;
  @Prop({default: ''}) private position!: string;
  @Prop({default: ''}) private eventLink!: string;
  @Prop({default: false}) private account!: boolean;
  @Prop({default: false}) private compact!: boolean;
  @Prop({default: false}) private isMobile!: boolean;
  @Prop({default: true}) private reveals!: boolean;
  @Prop({default: true}) private revealsOnMobile!: boolean;
  @Prop({default: 44}) private revealPartialHeight!: number;
  @Prop({default: false}) private open!: boolean;
  private localReveals = (this.revealsOnMobile || !this.isMobile);

  // public show() {
  //   if (this.$refs.card.overlay) {
  //     this.$refs.card.overlay.show()
  //   }
  //   if (this.localReveals && this.$refs.card.reveal) {
  //     this.$refs.card.reveal.open()
  //   }
  // }
  // public hide() {
  //   if (this.$refs.card.overlay) {
  //     this.$refs.card.overlay.hide()
  //   }
  //   if (this.localReveals && this.$refs.card.reveal) {
  //     this.$refs.card.reveal.close()
  //   }
  // }

}
